var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg24Floating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2959 6.70219C20.1914 6.59731 20.0672 6.5141 19.9304 6.45732C19.7937 6.40054 19.6471 6.37131 19.499 6.37131C19.351 6.37131 19.2043 6.40054 19.0676 6.45732C18.9309 6.5141 18.8067 6.59731 18.7021 6.70219L12 13.4044L5.2959 6.70219C5.08455 6.49085 4.79791 6.37212 4.49902 6.37212C4.20014 6.37212 3.91349 6.49085 3.70215 6.70219C3.4908 6.91354 3.37207 7.20018 3.37207 7.49907C3.37207 7.79795 3.4908 8.0846 3.70215 8.29594L11.2021 15.7959C11.3067 15.9008 11.4309 15.984 11.5676 16.0408C11.7043 16.0976 11.851 16.1268 11.999 16.1268C12.1471 16.1268 12.2937 16.0976 12.4304 16.0408C12.5672 15.984 12.6914 15.9008 12.7959 15.7959L20.2959 8.29594C20.4008 8.19143 20.484 8.06723 20.5408 7.93049C20.5976 7.79374 20.6268 7.64713 20.6268 7.49907C20.6268 7.351 20.5976 7.20439 20.5408 7.06765C20.484 6.9309 20.4008 6.80671 20.2959 6.70219Z",
    fill: "#6B7380"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24Floating);
export default __webpack_public_path__ + "static/media/24_Floating.5c8887cdf8414289392732e788f52c9c.svg";
export { ForwardRef as ReactComponent };